import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoChevronBack } from "react-icons/io5";
import style from "./TaskCompletion.module.css";
import InnerHeadBar from "../InnerHeadBar/InnerHeadBar";

const TaskCompletion = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { summary, courseName } = location.state || {
        summary: "Congratulations on completing your tasks!",
        courseName: "the course",
    };

    return (
        <div className={style.pageContainer}>
            <InnerHeadBar />

            <main className={style.mainContent}>
                <div className={style.celebrationSection}>
                    <div className={style.trophyContainer}>
                        <span className={style.trophyIcon}>🏆</span>
                        <div className={style.confetti}></div>
                    </div>

                    <h1 className={style.congratulationsText}>Congratulations!</h1>
                    <p className={style.completionSubText}>
                        You have successfully mastered <strong>{courseName}</strong>
                    </p>
                </div>

                <div className={style.summaryCard}>
                    <div className={style.cardHeader}>
                        <div className={style.aiIcon}>✨</div>
                        <h2>AI Learning Summary</h2>
                    </div>
                    <div className={style.cardBody}>
                        <p className={style.summaryText}>{summary}</p>
                    </div>
                </div>

                <div className={style.actions}>
                    <button
                        className={style.dashboardBtn}
                        onClick={() => navigate("/")}
                    >
                        Back to Dashboard
                    </button>
                    <button
                        className={style.learningsBtn}
                        onClick={() => navigate("/learnings")}
                    >
                        View All Learnings
                    </button>
                </div>
            </main>
        </div>
    );
};

export default TaskCompletion;
